import React from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import xss from 'xss'

import { Button } from '@wartek-id/button-v1'
import { Spinner } from '@wartek-id/spinner'

import {
  CPKvKeys,
  useGetCPKeyPairValue,
} from 'api/content-platform/useAPIKeyValue'
import { useUserGroupSjt } from 'utils/hooks/useUserGroup'
import LoadingState from 'app/PemetaanKompetensiPage/components/LoadingState'
import ForbiddenPage from '../components/ForbiddenPage'
import PeriodGuard from '../components/PeriodGuard'
import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'

import type { IUjikomContactData } from 'types/content-platform'

const DataTidakSesuai = ({ currentDateTimeServer }) => {
  const router = useRouter()
  const { isDesktop } = useMediaQueryHelper()

  const { hasAccess: hasNecessaryRole, isLoading: isLoadingNecessaryRole } =
    useUserGroupSjt()
  const isUjikomWhitelisted = !isLoadingNecessaryRole && hasNecessaryRole

  const { isLoading, data: ujikomContactData } =
    useGetCPKeyPairValue<IUjikomContactData>(
      CPKvKeys.UjikomContactContent,
      isUjikomWhitelisted
    )

  // To be displayed only if the role is being validated
  if (isLoadingNecessaryRole)
    return <LoadingState title="Halaman sedang dimuat..." />

  if (!isUjikomWhitelisted) return <ForbiddenPage />

  if (isLoading)
    return (
      <div className="w-full flex justify-center">
        <Spinner />
      </div>
    )

  return (
    <div className="relative flex flex-col max-w-ujikom mx-auto bg-gray-10">
      <PeriodGuard
        fullPageLoading
        currentDateTimeServer={currentDateTimeServer}
      >
        <div
          className="bg-white m-4 p-4 rounded-md ujikom-data-tidak-sesuai-wysiwyg"
          dangerouslySetInnerHTML={{
            __html: xss(ujikomContactData.data.contact_dapodik),
          }}
        ></div>
        <div
          className={clsx(
            'max-w-ujikom p-4 w-full',
            !isDesktop && 'fixed bottom-0'
          )}
        >
          <Button
            fullWidth={!isDesktop}
            className="float-right"
            size="lg"
            onClick={() => router.push('/pemetaan-kompetensi/pakta-integritas')}
          >
            {ujikomContactData.data.cta_button}
          </Button>
        </div>
      </PeriodGuard>
    </div>
  )
}

export default DataTidakSesuai
